var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 21,
    rx: 10.5,
    fill: "#459F49"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 21,
    rx: 10.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 6H7.25C6.5625 6 6 6.5625 6 7.25V14.75C6 15.4375 6.5625 16 7.25 16H14.75C15.4375 16 16 15.4375 16 14.75V7.25C16 6.5625 15.4375 6 14.75 6ZM13.5 11.625H8.5C8.15625 11.625 7.875 11.3438 7.875 11C7.875 10.6562 8.15625 10.375 8.5 10.375H13.5C13.8438 10.375 14.125 10.6562 14.125 11C14.125 11.3438 13.8438 11.625 13.5 11.625ZM11 14.125H8.5C8.15625 14.125 7.875 13.8438 7.875 13.5C7.875 13.1562 8.15625 12.875 8.5 12.875H11C11.3438 12.875 11.625 13.1562 11.625 13.5C11.625 13.8438 11.3438 14.125 11 14.125ZM13.5 9.125H8.5C8.15625 9.125 7.875 8.84375 7.875 8.5C7.875 8.15625 8.15625 7.875 8.5 7.875H13.5C13.8438 7.875 14.125 8.15625 14.125 8.5C14.125 8.84375 13.8438 9.125 13.5 9.125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentCircleIcon);
export default __webpack_public_path__ + "static/media/document-circle-icon.1531e32c18ff3a0747aa6bd293baabad.svg";
export { ForwardRef as ReactComponent };